<template>
  <div>
    <a-row type="flex" :gutter="30" style="padding-top:30px;">
      <a-col span="8" style="margin-bottom:25px;">
        <a-input-group compact>
          <a-select v-model="params.jobType" style="width:35%">
            <a-select-option value="job_id">职位ID</a-select-option>
            <a-select-option value="job_name">职位名称</a-select-option>
          </a-select>
          <a-input v-model="params.jobValue" style="width:65%" placeholder="请输入关键字"></a-input>
        </a-input-group>
      </a-col>
      <!-- <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">公司名称</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入关键字" v-model="params.company_name"></a-input>
          </a-col>
        </a-row>
      </a-col>-->
      <a-col span="8" style="margin-bottom:25px;">
        <a-input-group compact>
          <a-select v-model="params.main" style="width:35%">
            <a-select-option value="user_tel">猎头手机</a-select-option>
            <a-select-option value="user_email">猎头邮箱</a-select-option>
            <a-select-option value="user_name">猎头姓名</a-select-option>
          </a-select>
          <a-input v-model="params.mainValue" style="width:65%" placeholder="请输入关键字"></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-input-group compact>
          <a-select v-model="params.resume" style="width:35%">
            <a-select-option value="resume_mobile">候选人手机</a-select-option>
            <a-select-option value="resume_email">候选人邮箱</a-select-option>
            <a-select-option value="resume_name">候选人姓名</a-select-option>
          </a-select>
          <a-input v-model="params.resumeValue" style="width:65%" placeholder="请输入关键字"></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">IE</a-col>
          <a-col span="18">
            <a-auto-complete
              allowClear
              style="display:block"
              :dataSource="suggestion"
              @search="handleSearch"
              v-model="params.ie_user_id"
              placeholder="请输入关键字"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">订单号</a-col>
          <a-col span="18">
            <a-input style="display:block" placeholder="请输入关键字" v-model="params.order_no"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">订单状态：</a-col>
          <a-col span="18">
            <a-select style="display:block" v-model="params.statuses">
              <a-select-option
                v-for="item in options"
                :key="item.text"
                :value="item.value"
              >{{item.text}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button type="primary" style="margin-right:12px;padding:0 30px;" @click="getData()">筛选</a-button>
        <a-button style="margin-right:12px;" @click="resetParams">清空筛选条件</a-button>
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
    </a-row>
    <div class="data-table" style="padding:30px 0;">
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
        :customRow="rowClick"
      >
        <template slot="hunter" slot-scope="name">
          <span>{{name}}</span>
          <!-- <span class="badge" v-if="record.is_sign == 1">签</span> -->
        </template>
        <template slot="status" slot-scope="status">
          <span
            :class="{
              tag: true,
              blue:
                [
                  'CREATED',
                  'AUDIT_PASSED',
                  'AUDIT_FAILED',
                  'SUBMIT_FAILED'
                ].indexOf(status) > -1
            }"
          >推</span>
          <span
            :class="{
              tag: true,
              blue:
                [
                  'SUBMIT_PASSED',
                  'INTERVIEW',
                  'INTERVIEW_FAILED',
                  'CLOSED'
                ].indexOf(status) > -1
            }"
          >面</span>
          <span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }">录</span>
          <span
            :class="{
              tag: true,
              blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1
            }"
          >职</span>
          <span
            :class="{
              tag: true,
              blue:
                ['COMPLETED', 'NOT_COMPLETED', 'UNSETTLED', 'SETTLED'].indexOf(
                  status
                ) > -1
            }"
          >保</span>
        </template>
      </a-table>
    </div>
    <a-drawer
      :visible="drawer"
      :closable="false"
      width="1000"
      @close="drawer = !drawer"
      :destroyOnClose="true"
    >
      <a-row type="flex" justify="space-between" align="middle" style="paddingBottom:40px;">
        <a-col style="cursor:pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
        </a-col>
        <a-col style="cursor:pointer" @click="viewDetail">
          <a-icon type="fullscreen" />在新窗口打开
        </a-col>
      </a-row>
      <order-detail :id="order_id"></order-detail>
    </a-drawer>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import { mapState } from "vuex";
import baseComponentVue from "@/components/base-component.vue";
import debounce from "lodash/debounce";
import OrderDetail from "../order-detail";
export default {
  name: "postTab",
  extends: baseComponentVue,
  props: ['type'],
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      loading: false,
      dataSource: [],
      columns: [],
      suggestion: [],
      options: [],
      allStatus: { text: "全部", value: "" },
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {},
      order_id: undefined,
      drawer: false
    };
  },
  computed: {
    ...mapState(["orderStatus"])
  },
  created() {
    this.options = this.orderStatus;
    let arr = [];
    for (let key in this.orderStatus) {
      this.orderStatus[key].child.forEach(item => {
        if (item.text === "全部") {
          this.allStatus.value = this.allStatus.value
            ? this.allStatus.value + ","
            : "";
          this.allStatus.value += item.value;
        } else {
          arr.push(item);
        }
      });
    }
    this.options = [this.allStatus, ...arr];
    this.resetParams();
    this.setNoActionColums();
    this.getData();
  },
  components: { OrderDetail },
  methods: {
    setNoActionColums() {
      this.columns = [
        {
          title: "订单号",
          dataIndex: "order_no"
        },
        {
          title: "职位",
          dataIndex: "job_name"
        },
        {
          title: "客户名",
          dataIndex: "company_name"
        },
        {
          title: "候选人",
          dataIndex: "resume_name"
        },
        {
          title: "猎头",
          dataIndex: "hunter_name",
          scopedSlots: { customRender: "hunter" }
        },
        {
          align: "center",
          title: "订单阶段",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "订单状态",
          dataIndex: "status_text"
        },
        {
          title: "创建时间",
          dataIndex: "created_at"
        },
        {
          title: "最近状态变更时间",
          dataIndex: "updated_at"
        }
      ];
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        // created_start:
        //   this.params.time[0] && this.params.time[0].format("YYYY-MM-DD"),
        // created_end:
        //   this.params.time[1] && this.params.time[1].format("YYYY-MM-DD"),
        // province_id: this.params.city[0],
        // city_id: this.params.city[1],
        // dist_id: this.params.city[2],
        // company_name: this.params.company_name,
        statuses: this.params.statuses,
        [this.params.main]: this.params.mainValue,
        [this.params.resume]: this.params.resumeValue,
        [this.params.jobType]: this.params.jobValue,
        order_no: this.params.order_no,
        ie_user_id: this.params.ie_user_id,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        pm_type: this.type
      };
      try {
        let response = await Api.hunter.getPostData(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
      } catch (e) {}
      this.loading = false;
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;
            this.order_id = record.id;
          }
        }
      };
    },
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve(
        {
          path: `detail/${this.order_id}`
        },
        this.$route,
        true
      );
      window.open(resolveDRoute.href, "_blank");
    },
    resetParams() {
      let params = {
        main: "user_tel",
        jobType: "job_id",
        jobValue: "",
        mainValue: "",
        resume: "resume_mobile",
        resumeValue: "",
        ie_user_id: ""
      };
      this.params = { statuses: this.allStatus.value, ...params };
    },
    //IE 搜索建议
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.suggestion = arr;
    }
  }
};
</script>
<style lang="scss">
.tag {
  border: 1px solid #00a2eb;
  padding: 2px 3px;
  &.blue {
    color: #fff;
    background: #00a2eb;
  }
  &:not(:first-child) {
    border-left: none;
  }
}
</style>
